import React, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './finecoButton.module.css';

type ButtonVariant = 'default' | 'white' | 'ghost';

type FinecoButtonProps = {
  className?: string;
  click?: () => void;
  onClick?: (e: React.MouseEvent) => void;
  copy: string;
  disabled?: boolean;
  variant?: ButtonVariant;
  testId?: string;
};

const variantStyles: Record<ButtonVariant, string | undefined> = {
  default: undefined,
  white: styles.whiteVariant,
  ghost: styles.ghostVariant,
};

export const FinecoButton = forwardRef<HTMLButtonElement, FinecoButtonProps>(
  ({ className, click, onClick, copy, disabled = false, variant = 'default', testId }, ref) => {
    const handleClick = (e: React.MouseEvent) => {
      if (disabled) return;
      onClick?.(e);
      click?.();
    };

    return (
      <button
        ref={ref}
        type="button"
        className={classNames(
          className,
          styles.button,
          variantStyles[variant],
          disabled ? styles.notAllowed : styles.allowed,
        )}
        style={{ width: 'auto' }}
        onClick={handleClick}
        disabled={disabled}
        data-testid={testId}
      >
        {copy}
      </button>
    );
  },
);

FinecoButton.displayName = 'FinecoButton';
